module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-font-daa5e68e.svg";